const BASE_KEY = "apps-search-filters";

export const appsSearchQueryKeys = {
    description: () => [BASE_KEY, "description"] as const,
} as const;
